export default __webpack_public_path__ + "static/media/chat-bg-h5.9c8b4096.png";